const updateHubspotHiddenField = () => {
  const colorSource = document.querySelector(`.product-form__input--swatch span[data-selected-value]`);
  const titleSource = document.querySelector(`a.product__title`);
  const destinations = document.querySelectorAll(`input.hs-input[name="product_id_and_color"]`);

  if (colorSource && titleSource && destinations.length) {
    destinations.forEach(destination => {
      destination.value = titleSource.textContent + ' - ' + colorSource.textContent;
    });
  }
};

const attachListenersToButtons = () => {
  const buttons = document.querySelectorAll('input.hs-button.primary.large');
  buttons.forEach(button => {
    // Avoid attaching the same listener more than once
    if (!button.dataset.listenerAttached) {
      button.addEventListener('mouseenter', updateHubspotHiddenField);
      button.dataset.listenerAttached = 'true'; // flag to prevent duplication
    }
  });
};

const observeDOMForButtons = () => {
  // Run once in case buttons are already on the page
  attachListenersToButtons();

  // Observe future changes
  const observer = new MutationObserver(() => {
    attachListenersToButtons();
  });

  observer.observe(document.body, { childList: true, subtree: true });
};

document.addEventListener('DOMContentLoaded', observeDOMForButtons);